import Translation from "./Translation"

export default function Projects() {
    return (
        <div className="projects">
            <div className="legend">{ Translation("Projets") }</div>
            <ul className="wrapper">
                <li>Knauf</li>
                <li>Parlement</li>
                <li>BeIN Sport</li>
                <li>EasyOrder</li>
                <li>1001Pharmacies</li>
                <li>Publifer</li>
                <li>CHULille</li>
                <li>Amex</li>
            </ul>
        </div>
    )
}